import React from "react";
import helixdigital from "../assets/portfolio/helixdigital.png";
import tdp from "../assets/portfolio/tdp.png";
import idealdukaan from "../assets/portfolio/idealdukaan.png";
import textutils from "../assets/portfolio/textutils.png";
import weatherapp from "../assets/portfolio/weatherapp.png";
import githubfetch from "../assets/portfolio/githubfetch.png";

const Portfolio = () => {
  const portfolios = [
    {
      id: 1,
      src: tdp,
      link: "https://thedigitalphenomena.com/",
    },
    {
      id: 2,
      src: helixdigital,
      link: "https://www.helixdigital.com.pk/",
    },
    {
      id: 3,
      src: idealdukaan,
      link: "https://www.idealdukaan.pk/",
    },
    {
      id: 4,
      src: textutils,
      link: "https://textutils-react.netlify.app/",
    },
    {
      id: 5,
      src: weatherapp,
      link: "https://weathertrackerapplication.netlify.app/",
    },
    {
      id: 6,
      src: githubfetch,
      link: "https://fetch-github-user.netlify.app/",
    },
  ];

  return (
    <div name="portfolio" className="w-full text-white md:h-screen portfolio">
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <h3 className="text-4xl font-bold inline border">Portfolio</h3>
          <p className="py-6">Check out some of my work right here</p>
        </div>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolios.map(({ id, src, link }) => (
            <div key={id} className="rounded-lg shadow portfolio-sizing">
              <img
                src={src}
                alt="projects"
                className="rounded-md duration-200 hover:scale-105"
              />
              <div className="flex items-center justify-center">
                <button
                  className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105"
                  onClick={() => window.open(link, "_blank")}
                >
                  Visit Site
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Portfolio;